import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const NoteIndicatorIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 0h12v2L0 2.01V0Zm12 5.01L0 5v2h12V5.01ZM0 10h6v2H0v-2Z"  />
    </SvgIcon>
);
